import { render, staticRenderFns } from "./deliverySet.vue?vue&type=template&id=71ed0599&scoped=true&"
import script from "./deliverySet.vue?vue&type=script&lang=js&"
export * from "./deliverySet.vue?vue&type=script&lang=js&"
import style0 from "./deliverySet.vue?vue&type=style&index=0&id=71ed0599&lang=scss&scoped=true&"
import style1 from "./deliverySet.vue?vue&type=style&index=1&id=71ed0599&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed0599",
  null
  
)

export default component.exports